/**
 * 个人中心
 */

import { smb_fetch, getAgpApiUrl, getAgsApiUrl, getAgpAgmsApiUrl } from '@/api/operator/fetch';

/**
 * 获取基础信息
 */
export const getUserBaseInfo = (data) => {
  const url = getAgpApiUrl('user', 'get_user_base_info');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};

/**
 * 获取学习信息
 */
export const getUserStudyInfo = (data) => {
  const url = getAgpApiUrl('user', 'get_user_study_info');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};

/**
 * 获取验证码
 */
export const sendSmsVerify = (data) => {
  const url = getAgpApiUrl('user', 'send_sms_verify');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};
/**
 * 保存手机号
 */
export const storeUserInfo = (data) => {
  const url = getAgpApiUrl('user', 'store_user_info');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};

/**
 * 保存微信号
 */
export const storeWechatInfo = (data) => {
  const url = getAgpAgmsApiUrl('user', 'wx_id/update');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};

/**
 * 校验微信号是否存在
 */
export const storeVerifyWechat = (data) => {
  const url = getAgpAgmsApiUrl('user', 'wx_id/check');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};

/**
 * 跳转微信扫码
 */
export const gotoLoginPage = (type) => {
  const url = `https://sso.e.qq.com/login/${type === 0 ? 'qq' : 'wx'}?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=48`;
  location.href = url;
};

/**
 * 校验微信扫码获取 ticket 是否有效
 */
export const storeWechatCheckTicket = (data) => {
  const url = getAgpAgmsApiUrl('user', 'ticket/check');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};

/**
 * 是否显示个人中心提示
 */
export const showTip = (data) => {
  const url = getAgpApiUrl('user', 'show_tip');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};
/**
 * 保存当天是否登录
 */
export const tipConfirm = (data) => {
  const url = getAgpApiUrl('user', 'tip_confirm');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params, true);
};
/**
 * 获取任务列表
 * @return
 */
export const getTaskList = (data) => {
  const url = getAgpApiUrl('task', 'get_summary');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取用户自定义配置
 * @param {*} data
 * @returns
 */
export const getUserCustomConfig = (data) => {
  const url = getAgpApiUrl('user', 'get_customer_ui');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params, false, false);
};

/**
 * 更新用户自定义配置
 * @param {*} data
 * @returns
 */
export const updateUserCustomConfig = (data) => {
  const url = getAgpApiUrl('user', 'store_customer_ui');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params, false, false);
};

/**
 * 获取用户有权限的服务商列表
 * @param {*} data
 * @returns
 */
export const getAgencyListWithFinanceInfo = (data) => {
  const url = getAgpApiUrl('user', 'get-agency-list');
  const params = $.extend(
    true,
    {
      method: 'get',
    },
    data,
  );
  return smb_fetch(url, params, false);
};

/**
 * 获取个人中心获取企微ID、是否订阅
 */
export const getWxCorpInfo = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'wxCorp/info/get');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, true, false);
};

/**
 * 添加/取消企微消息订阅
 */
export const updateWxCropSubscribe = (data) => {
  const url = getAgsApiUrl('agency_sales_portal', 'wxCorp/update');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  return smb_fetch(url, params, true, false);
};
